module.exports = __webpack_public_path__ + "img/Infografis_ID_10.553cba92.jpg";